export const newLinesToBreaks = (text = "") => {
  return text.replace(/\n/g, "<br />");
};
